module.exports = __webpack_public_path__ + "img/3.64eceda9.png";